module.exports = __webpack_public_path__ + "static/media/matrix-light.74669c73.svg";